import { People, User } from '../types';

export const DEFAULT_IDENTIFIER = '-';
export function getPersonIdentifier(person: People): string {
  if (person.fullname) return person.fullname;

  if (!person.email) return person.name ?? DEFAULT_IDENTIFIER;

  return person.email
    .split('@')[0]
    .split('.')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1).toLowerCase())
    .join(' ');
}

export function getUserIdentifier(user: User): string {
  if (user.people) {
    return getPersonIdentifier(user.people);
  }
  return user.primary_email;
}
